import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { toRef } from 'vue'

interface IProps {
  color: string
  width?: string
  height?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KColourLine' },
  __name: 'KColourLine',
  props: {
    color: {},
    width: { default: '8px' },
    height: { default: '24px' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v830bfe24": (widthRef.value),
  "v98c383ea": (heightRef.value),
  "v28a6839e": (colorRef.value)
}))


const props = __props

const colorRef = toRef(() => props.color)
const widthRef = toRef(() => props.width)
const heightRef = toRef(() => props.height)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-colour-line", { 'self-stretch': __props.height === 'auto' }])
  }, null, 2))
}
}

})